/**
 * aida-spa
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ReportTypeDTO = {
    bookings: 'bookings',
    cancellations: 'cancellations',
    special: 'special',
    comfort_all_in: 'comfort_all_in'
} as const;
export type ReportTypeDTO = typeof ReportTypeDTO[keyof typeof ReportTypeDTO];

